import PageShell from '../components/PageShell.jsx';
import {
  QUIZ_RULES,
  CONTACT,
  PRIVACY,
  TERMS,
  COOKIES,
} from '../data/staticPages.js';

function Sections({ data }) {
  return (
    <div className="space-y-4">
      {data.sections.map((s) => (
        <div key={s.heading} className="surface-card rounded-2xl p-6">
          <h2 className="text-sm font-black uppercase tracking-widest text-brand mb-2">
            {s.heading}
          </h2>
          <p className="text-sm text-slate-600 leading-relaxed">{s.body}</p>
        </div>
      ))}
    </div>
  );
}

export function QuizRulesPage() {
  return (
    <PageShell title={QUIZ_RULES.title} intro={QUIZ_RULES.intro}>
      <ol className="space-y-3">
        {QUIZ_RULES.items.map((item, i) => (
          <li key={i} className="surface-card rounded-2xl p-5 flex gap-4">
            <span className="text-brand font-black text-lg shrink-0">{i + 1}.</span>
            <span className="text-sm text-slate-600 leading-relaxed">{item}</span>
          </li>
        ))}
      </ol>
      <p className="text-sm text-slate-400 mt-6 text-center">{QUIZ_RULES.footer}</p>
    </PageShell>
  );
}

export function ContactPage() {
  return (
    <PageShell title={CONTACT.title}>
      <div className="space-y-4">
        {CONTACT.blocks.map((b) => (
          <div key={b.heading} className="surface-card rounded-2xl p-6">
            <h2 className="text-sm font-black uppercase tracking-widest text-brand mb-2">
              {b.heading}
            </h2>
            <p className="text-sm text-slate-600 leading-relaxed">{b.body}</p>
          </div>
        ))}
      </div>
    </PageShell>
  );
}

export function PrivacyPage() {
  return (
    <PageShell title={PRIVACY.title} intro={PRIVACY.intro}>
      <Sections data={PRIVACY} />
    </PageShell>
  );
}

export function TermsPage() {
  return (
    <PageShell title={TERMS.title} intro={TERMS.intro}>
      <Sections data={TERMS} />
    </PageShell>
  );
}

export function CookiesPage() {
  return (
    <PageShell title={COOKIES.title} intro={COOKIES.intro}>
      <Sections data={COOKIES} />
    </PageShell>
  );
}
